import { UserModelJsonResource, UserPreferencesInput } from "@/types/userTypes";
import api from "./axios";

/**
 * Settings API functions for managing user preferences and profile settings
 */
export class SettingsApi {
  /**
   * Update user preferences (weight unit and date range)
   * @param preferences - The preferences to update
   * @returns The updated user data
   */
  async updatePreferences(
    preferences: UserPreferencesInput
  ): Promise<UserModelJsonResource> {
    const response = await api.post("/api/preferences", preferences);
    return response.data.user;
  }

  /**
   * Update user profile (gender, birth year)
   * @param profileData - The profile data to update
   * @returns The updated user data
   */
  async updateProfile(
    profileData: Record<string, unknown> // Use a generic record to avoid 'any' lint error
  ): Promise<UserModelJsonResource> {
    const response = await api.post("/api/profile", profileData);
    return response.data.user;
  }

  /**
   * Check ticket submission rate limit status
   * @returns The rate limit information
   */
  async checkTicketRateLimit(): Promise<{
    rate_limit_reached: boolean;
    remaining_tickets: number;
    total_limit: number;
    period_hours: number;
    reset_time: string | null;
    recent_tickets_count: number;
  }> {
    const response = await api.get("/api/tickets/rate-limit");
    return response.data;
  }

  /**
   * Submit a support ticket/content
   * @param ticketData - The ticket data
   * @returns The response with ticket information
   */
  async submitTicket(
    ticketData: { content: string }
  ): Promise<{ message: string; ticket_id: string }> {
    const response = await api.post("/api/tickets/submit", ticketData);
    return response.data;
  }
}

export const settingsApi = new SettingsApi();
